import axios from "axios";

const state = {
  user: null,
  fnames: ['Pinky', 'Smuts', 'Chester', 'Len', 'Trojan', 'Binkie', 'Mel', 'Dolly', 'Kipper', 'Dan', 'Percy', 'Colin', 'Dingle', 'Herb', 'Vic', 'Rocco', 'Lee', 'Pep', 'Wolfgang', 'Lamont', 'Duke', 'Glenn', 'Lucy', 'Peppa', 'Judas', 'Susan', 'Dot', 'Puff', 'Fred', 'Moseph', 'Nadine', 'Ziggy', 'Maureen', 'Danger', 'Fresh', 'Fluffkin', 'Noggin', 'Toots', 'Garfield', 'Jaws', 'Cuthbert', 'Hogan', 'Lady', 'June', 'Lucifer', 'Herminone', 'Gert', 'Clem', 'Max', 'Ray', 'Mrs', 'Duncan', 'Winky', 'Mick'],
  snames: ['Badger', 'Littlewang', 'Smith', 'Prawn', 'Old-Man', 'Hurts', 'Kinderegg', 'Pig', 'MostDandy', 'Bangle', 'Halfpipe', 'Noseworthy', 'Highlander', 'Trump', 'Fjortoft', 'Boats', 'Ng', 'Lemonjuice', 'McHaggis', 'Offal', 'Triceratops', 'Plaything', 'Itteration', 'Wazzock', 'Clownfish', 'Gruffalo', 'Bigwave', 'Bendy', 'Bumhole', 'Moist', 'Petrol', 'Woohoo', 'Shiver', 'Toast', 'Javascript', 'Brown-Nose', 'Windsor', 'Potty', 'Snailshell', 'Fandango', 'Purchase', 'Gland', 'Clench', 'Steeples', 'Makepeace', 'Spasm'],
};

const getters = {
  loggedIn(state) { return !!state.user },
  user(state) { return state.user },
  fnames(state) { return state.fnames },
  snames(state) { return state.snames },
};

const actions = {
  regUser({ commit }, credentials) {
    return axios.post(process.env.VUE_APP_API_URL + 'auth/register', credentials)
  },
  getToken({ commit }, credentials) {
    return axios
    .post(process.env.VUE_APP_API_URL + 'auth/login', credentials)
    .then(({ data }) => {
      commit('SET_TOKEN', data)
    })
  },
  getUser({ commit }) {
    return axios
    .get(process.env.VUE_APP_API_URL + 'auth/user')
    .then(({ data }) => {
      commit('SET_USER', data)
    })
  },
  requestPasswordReset({ commit }, credentials) {
    return axios.post(process.env.VUE_APP_API_URL + 'auth/forgotten_password', credentials)
  },
  resetPassword({ commit }, credentials) {
    return axios.post(process.env.VUE_APP_API_URL + 'auth/reset_password', credentials)
  },
  logout({ commit }) {
    commit('LOGOUT');
  },
};

const mutations = {
  SET_TOKEN(state, data) {
    //ADD IN IONIC VERSION OF LOCALSTORAGE
    localStorage.setItem('tenp_token', JSON.stringify(data));
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.data.access_token}`;
  },
  SET_USER(state, data) {
    state.user = data;
    //ADD IN IONIC VERSION OF LOCALSTORAGE
    localStorage.setItem('tenp_user', JSON.stringify(data));
  },
  LOGOUT() {
    localStorage.removeItem('tenp_user');
    localStorage.removeItem('tenp_token');
    location.reload();
  },
};


export default {
  state,
  getters,
  actions,
  mutations,
}
